module.exports = __webpack_public_path__ + "static/img/enterprise-policy-hover.bba98bff.png";